export const selectCurrentParticipantUniqueId = state =>
  state.SessionReducer.uniqueId;
export const selectSessionKey = state =>
  state.SessionReducer.sessionDetails.sessionKey;
export const selectSnapshoteeId = state => state.SessionReducer.snapshoteeId;
export const selectSnapshoterId = state => state.SessionReducer.snapshoterId;
export const selectSnapshotPermissionReply = state =>
  state.SessionReducer.snapshotPermissionReply;
export const selectIsSnapshotTaken = state =>
  state.SessionReducer.isSnapshotTaken;
export const selectOrganiser = state => {
  return state.RoomMetaDataReducer.roomMetaData.organiser;
};
export const selectShowSnapshot = state => {
  return state.SessionReducer.showSnapshot;
};
export const getComponentInFocus = state =>{
  return state.SessionReducer.componentInFocus;
};
export const getSaveSessionDataFlag = state => {
  return state.SessionReducer.saveSessionDataFlag;
};
export const getSessionType = state => {
  return state.SessionReducer.sessionType;
};
export const selectOrganiserParticipantId = state => {
  let organiser = state.ParticipantReducer.participants.filter(participant => participant.role === "AGENT")[0];
  return organiser ? organiser.participantId : null;
}
export const selectIsSnapShotRunning = state => {
  return state.SnapshotReducer.isSnapshotRunning
}
export const getRecordingMethod = state => {
  return (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.recordingMethod)
};
export const getRecordingTarget = state => {
  return (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.recordingTarget)
};
export const getIsRecording = state => {
  return state.SessionReducer.isRecording
}
export const getModalRecordingMessage = state => {
  return (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.modalRecordingMessage)
}
export const getAudioRecordingMessage = state => {
  return (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.audioRecordingMessage)
}
export const getVideoRecordingMessage = state => {
  return (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.videoRecordingMessage)
}
export const getIsScreenMasking = state => {
  return state.SessionReducer.isScreenMasking
}
export const getRunScreenShare = state => {
  return state.SessionReducer.runScreenShare;
}
export const getShowPreviewModal = state => {
  return state.SessionReducer.showPreviewModal;
}
export const getIsVideoTransform = state => {
  return state.SessionReducer.isVideoTransform;
}
export const getPreviewAudio = state => {
  return state.SessionReducer.previewAudio;
}
export const getAudioDeviceId = state => {
  return state.SessionReducer.audioDeviceId;
}
export const getVideoDeviceId = state => {
  return state.SessionReducer.videoDeviceId;
}
export const getFacingMode = state => {
  return state.SessionReducer.facingMode;
}
export const getShowAudioSettingModal = state => {
  return state.SessionReducer.showAudioSettingModal;
}
export const getIsFullScreenV2 = state => {
  return state.SessionReducer.isFullScreenV2;
}
export const getIsVirtualBackground = state => {
  return state.SessionReducer.isVirtualBackground;
}
export const getSelectedBackground = state => {
  return state.SessionReducer.selectedBackground;
}
export const getDisableCanvasEdit = state => {
  return (
    (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.disableCanvasEdit) ||
    (state.OrganisationReducer.customerData && state.OrganisationReducer.customerData.disableCanvasEdit)
  );
};
export const selectSessionStatus = state => {
  return state.SessionReducer.sessionDetails.sessionStatus;
};
export const selectSessionName = state => {
  return state.SessionReducer.sessionDetails.sessionName;
};
export const selectIsCalling = state => {
  return state.SessionReducer.userSessionDetails.isCalling
}
export const selectIsSessionEnded = state => {
  return state.SessionReducer.isSessionEnded;
};
export const selectSessionType = state => {
  return (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.sessionType);
};
export const getLoggingLevel = state => {
  return state.SessionReducer.sessionDetails.loggingLevel;
};
export const  getDisableCanvasDownload = state => {
  return (
    (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.disableCanvasDownload) ||
    (state.OrganisationReducer.customerData && state.OrganisationReducer.customerData.disableCanvasDownload)
  );
};

/**
 * getContractInfo
 * @param {*} state
 * @returns [{ url, label }, { url, label }, ...]
 */
export const getContractInfo = (state) => {
  return state.SessionReducer.contractInfo;
};

/**
 * getIsContractInfoModalOpened
 * @param {*} state
 * @returns boolean true: ContractInfoModal is opened, false: ContractInfoModal is closed
 */
export const getIsContractInfoModalOpened = (state) => {
  return state.SessionReducer.isContractInfoModalOpened;
};

export const getIsSnapshotSave = (state) => {
  return state.SessionReducer.isSnapshotSave;
};

export const getIsSnapShotUploading = (state) => {
  return state.SessionReducer.isSnapShotUploading;
};

export const selectIsDisconnectedWhileCalling = state => {
  return state.SessionReducer.isDisconnectedWhileCalling;
};

export const selectIsSupportCenterSessionEnded = state => {
  return state.SessionReducer.isSupportCenterSessionEnded;
};

export const getEnableVideoBlur = state => {
  return (
    (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.enableVideoBlur) ||
    (state.OrganisationReducer.customerData && state.OrganisationReducer.customerData.enableVideoBlur)
  );
}

export const getIsPreviewResize = state => {
  return (
    (state.SessionReducer.sessionDetails && state.SessionReducer.sessionDetails.isPreviewResize) ||
    (state.OrganisationReducer.customerData && state.OrganisationReducer.customerData.isPreviewResize)
  );
}

export const getWebRtcReconnectingParticipantId = state => {
  return state.SessionReducer.webRtcReconnectingParticipantId;
}
